<template>
    <div>
      <img :src="qrCodeUrl" alt="QR Code" />
      <input type="text" placeholder="Enter OTP" v-model="otp">
      <button @click="verifyOTP">Verify</button>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        qrCodeUrl: '',
        otp: ''
      };
    },
    methods: {
      verifyOTP() {
        // Llamar a la API para verificar el OTP
      }
    }
  }
  </script>  